<!-- <img [src]="src" #image (error)="loadError()" (mousedown)="panStart($event)" (load)="loaded()"> -->
<angular-cropper
  #editor
  [cropperOptions]="config"
  (ready)="loaded()"
  [imageUrl]="src"
>
</angular-cropper>
